/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ImportTypeEnum = zod
    .enum(['orgUnit', 'instance', 'bulk', 'storageLog'])
    .describe(
        '\* `orgUnit` - Org Unit\n\* `instance` - Form instance\n\* `bulk` - Bulk Org Units and Instances\n\* `storageLog` - Storage logs',
    );

export type ImportTypeEnum = zod.input<typeof ImportTypeEnum>;
export type ImportTypeEnumOutput = zod.output<typeof ImportTypeEnum>;
